export default __webpack_public_path__ + "static/media/exhibitor.8776f63c.jpg";